import { Container } from 'src/components/common/Container'
import {
  ChipsActiveStyle,
  ChipsDefaultStyle,
  ChipsItemsBigStyle,
  ChipsItemStyle,
  ChipsListStyle,
} from 'src/components/common/Chips'
import { CategoryListSpace } from 'src/types/api'
import { css } from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import useContentsTopLevelDetection from 'src/hooks/useContentsTopLevelDetection.hook'
import { AlwaysDiscountCouponPageProps } from 'src/pages/AlwaysDiscounCouponPage'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { useEffect, useRef } from 'react'
import { SwiperRef } from 'swiper/swiper-react'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import usePageNav from 'src/hooks/usePageNav.hook'

const AlwaysDiscountChipsList = ({
  categoryData,
  alwaysCategory,
}: Pick<AlwaysDiscountCouponPageProps, 'categoryData' | 'alwaysCategory'>) => {
  //todo asis|swiper => tobe| web: swiper / aos,ios : x scroll
  const { contentsRef, detector } = useContentsTopLevelDetection(99)
  const swiperRef = useRef<SwiperRef>(null)
  const { alwaysPageNav } = usePageNav()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [prevAlwaysCategory, _setPrevAlwaysCategory, removePrevAlwaysCategory] =
    useLocalStorage<number>('prev_always_category', Number(alwaysCategory))
  const swiperClickTrigger = (categoryNumber: number) => {
    const categoryOrder = categoryData?.findIndex((w) => w.CategoryNumber === categoryNumber)

    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(categoryOrder)
    }
  }

  useEffect(() => {
    if (!!prevAlwaysCategory) {
      swiperClickTrigger(prevAlwaysCategory)
      removePrevAlwaysCategory()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container $option="flex_column" $style={S.AlwaysChipsListContainer()} ref={contentsRef}>
      <CustomSwiper.Wrap
        type="default"
        gap={6}
        $wrapstyle={S.AlwaysChipsSwiperStyle(detector)}
        ref={swiperRef}
      >
        {categoryData?.map(
          ({ CategoryName, CategoryNumber }: CategoryListSpace.CategoryInfoType) => {
            const chipsActive = Number(alwaysCategory) === CategoryNumber
            const handleSwiperItems = () => {
              swiperClickTrigger(CategoryNumber)
              alwaysPageNav(CategoryNumber, true)
            }
            return (
              <CustomSwiper.Item
                key={CategoryNumber}
                onClick={handleSwiperItems}
                $itemstyle={S.AlwaysChipsSwiperItemsStyle(chipsActive)}
              >
                {CategoryName}
              </CustomSwiper.Item>
            )
          },
        )}
      </CustomSwiper.Wrap>
    </Container>
  )
}

export default AlwaysDiscountChipsList

const S = {
  AlwaysChipsListContainer: () => css`
    ${layoutMaxSize};
    height: 60px;
  `,
  AlwaysChipsSwiperStyle: ($position_change: boolean) => css`
    ${ChipsListStyle()};
    ${layoutMaxSize};
    padding: 10px 20px 6px 20px;
    position: ${$position_change ? 'fixed' : 'absolute'};
    top: ${$position_change ? '40px' : 'unset'};
    background: var(--white);
    z-index: ${ZIndex.CategoryChips};
    border-bottom: ${$position_change ? '1px solid #ededed' : 'none'};
  `,
  AlwaysChipsSwiperItemsStyle: (active?: boolean) => css`
    ${ChipsItemStyle};
    ${ChipsItemsBigStyle};
    ${active ? ChipsActiveStyle() : ChipsDefaultStyle()};
  `,
}
